
import { Select, Option } from 'element-ui';
import { Menu as MenuApi, Location, Concept, Employee, Category as CategoryApi } from '@/services/SOLO';
import {
  Category as CategoryModel,
  Location as LocationModel,
  Application as ApplicationModel,
} from '@/models';
import { Imagetype } from '@/interfaces/SOLO';
import { Component, Prop, Vue, Watch, Emit } from 'vue-property-decorator';
import { eventHandler, translations } from '@/mixins';
import {
  ValidationObserver,
  configure,
  ValidationProvider,
} from 'vee-validate';
import MenuRoles from '@/directives/menuRoles';
import { ElNotification } from 'element-ui/types/notification';
import { required, email } from 'vee-validate/dist/rules';
import { mapGetters } from 'vuex';

interface ObjKey {
  [x: string]: string | number;
}

@Component({
  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    ValidationProvider,
  },
  computed: {
    ...mapGetters({
      getUser: 'account/getUser',
      getLocale: 'app/getLocale',
      userRole: 'account/getUserRole',
      getConceptSettings: 'account/getConceptSettings',

    }),
  },
  directives: {
    MenuRoles,
  },
  mixins: [eventHandler, translations],
})
export default class Menu extends Vue {
  @Prop() menuId!: string;
  @Prop() categoryId!: string;
  @Prop() categories!: Array<CategoryModel>;
  @Prop() numOfLoadedData!: number;
  @Prop() arrayLang!: Array<string>;
  @Prop() active!: boolean
  getConceptSettings!: any
  stockImages: any = [];
  searchStock: any = '';
  isLoading = false;
  selectedLocations: any = [];
  notBelongLocations: any = [];
  selectedApplications: any = [];
  defaultLocations: Array<LocationModel> = [];
  defaultApplications: Array<ApplicationModel> = [];
  locations: Array<LocationModel> = [];
  applications: Array<any> = [];
  catNames: ObjKey = {};
  catDesc: ObjKey = {};
  imageType = 0;
  $notify: any;
  file: any;
  waiting!: Function;
  restore!: Function;
  getLang!: Function;
  getLanguages!: Function
  getLocale!: any;
  getUser!: any;
  userRole!: any;
  employeeLocations: any = [];

  // Pagination properties for locations
  currentPage = 1;
  perPage = 100;
  totalLocations = 0;
  isLoadingMore = false;

  // Dropdown state
  isDropdownOpen = false;
  searchQuery = '';

  imageTypes: Array<Record<string, any>> = [
    {
      value: 0,
      text: 'Image URL',
    },
    {
      value: 1,
      text: 'Image',
    },
    {
      value: 2,
      text: 'Stock Images',
    },
  ];

  $refs!: {
    formValidator: InstanceType<typeof ValidationObserver>;
    file: any;
  };

  @Watch('imageType', { deep: true, immediate: true })
  onChangeGetSotckImages (data: any) {
    if (data === 2) {
      this.searchStock = this.categories[0].attributes.name;
      this.searchStockImages(this.searchStock);
    }
  }

  @Watch('numOfLoadedData', { immediate: true, deep: true })
  onLoad (data: number) {
    console.log('data', data);
    if (data === 2) {
      this.categories[0].relationships.apps.data.map((data: any) => {
        this.selectedApplications.push(data.id);
      });

      if (this.categories[0]?.relationships?.locations?.data?.length) {
        const locationsData = this.categories[0]?.relationships?.locations?.data;
        const mapData = (data: any) => data?.id;
        if (this.isMenuRestaurant) {
          this.getEmployeeLocations()
            .then(() => {
              this.selectedLocations = locationsData
                .filter((l: any) => this.employeeLocations.find((lo: any) => l?.id === lo?.id))
                .map(mapData);
              this.notBelongLocations = locationsData
                .map(mapData)
                .filter((lo: any) => !this.selectedLocations.includes(lo));
            });
        } else {
          this.selectedLocations = locationsData.map(mapData);
        }
      }
    }
  }

  mounted () {
    this.getApps();
    this.getLocations();

    // Add click outside listener for dropdown
    document.addEventListener('click', this.handleClickOutside);
  }

  beforeDestroy () {
    // Remove click outside listener
    document.removeEventListener('click', this.handleClickOutside);
  }

  get isEnabled (): boolean {
    if (this.numOfLoadedData === this.arrayLang.length) { return !!this.categories[0].attributes.enabled; } else return false;
  }

  set isEnabled (newVal: boolean) {
    this.categories[0].attributes.enabled = newVal ? 1 : 0;
  }

  searchStockImages (e: any) {
    this.isLoading = true;
    CategoryApi.searchStockImgs(e)
      .then((response) => {
        this.stockImages = response.data.data;
        this.isLoading = false;
      });
  }

  selectStockImage (stockImage: any) {
    this.categories[0].attributes['image-uri'] = stockImage;
  }

  getApps () {
    Concept.find().then((response: any) => {
      this.applications = response.data.data.map((data: any) => {
        return {
          id: data.id.toString(),
          label: data.label,
        };
      });
    });
  }

  checkSize (text: any) {
    if (this.getLocale === 'en_US') {
      if (text === 'The image field size must be less than 2000KB') {
        return 'The image file size must be less than 2MB';
      }
    }
    if (text === 'The image field size must be less than 2000KB') {
      return 'يجب أن يكون حجم ملف الصورة أقل من 2 ميغا بايت';
    }
  }

  getEmployeeLocations () {
    if (!this.employeeLocations.length) {
      return Employee.find(this.getUser.id)
        .then((response) => {
          if (response.data.included) {
            this.employeeLocations = response.data.included;
          }
        });
    }
    return Promise.resolve();
  }

  private get isMenuRestaurant (): boolean {
    const filterRole = ['menu', 'restaurant'];
    const roles = this.userRole.filter((role: string) => filterRole.find((frole: string) => role === frole));
    return !!roles?.length;
  }

  getLocations (page = 1) {
    const lang = this.getLocale;
    Location.fetchLocations(lang, page, this.perPage).then((response: any) => {
      // filter locations for menu and restaurant
      // SPO-94
      // [Web] Users :: Restaurant and Menu - Disable Locations
      if (page === 1) {
        // Reset locations array for first page
        this.locations = response.data.data;
        this.currentPage = 1;
      } else {
        // Concatenate new data to existing locations for subsequent pages
        this.locations = this.locations.concat(response.data.data);
      }
      this.totalLocations = response.data.meta.pagination.total;

      if (this.isMenuRestaurant) {
        this.getEmployeeLocations()
          .then(() => {
            this.locations = this.locations.filter((l: any) => this.employeeLocations.find((lo: any) => l?.id === lo?.id));
            this.totalLocations = this.locations.length;
          });
      }
    }).finally(() => {
      this.isLoadingMore = false;
    });
  }

  loadMoreLocations () {
    this.isLoadingMore = true;
    this.currentPage++;
    this.getLocations(this.currentPage);
    // Keep dropdown open while loading more
  }

  get hasMoreLocations (): boolean {
    // Check if there are more pages available from the API
    return this.locations.length < this.totalLocations;
  }

  get displayedLocations (): Array<LocationModel> {
    // Return all loaded locations since we're accumulating data from multiple pages
    return this.locations;
  }

  get filteredLocations (): Array<LocationModel> {
    if (!this.searchQuery.trim()) {
      return this.displayedLocations;
    }

    const query = this.searchQuery.toLowerCase().trim();
    return this.displayedLocations.filter((location) =>
      location.attributes.name.toLowerCase().includes(query),
    );
  }

  getLocationName (locationId: string): string {
    const location = this.locations.find((l) => l.id === locationId);
    return location ? location.attributes.name : locationId;
  }

  toggleLocation (locationId: string) {
    if (this.selectedLocations.includes(locationId)) {
      this.selectedLocations = this.selectedLocations.filter((id: string | number) => id !== locationId);
      this.notBelongLocations.push(locationId);
    } else {
      this.selectedLocations.push(locationId);
      this.notBelongLocations = this.notBelongLocations.filter((id: string | number) => id !== locationId);
    }
  }

  removeLocation (locationId: string) {
    this.selectedLocations = this.selectedLocations.filter((id: string | number) => id !== locationId);
    this.notBelongLocations.push(locationId);
  }

  toggleDropdown () {
    this.isDropdownOpen = !this.isDropdownOpen;
    // Clear search when opening dropdown
    if (this.isDropdownOpen) {
      this.searchQuery = '';
    }
  }

  filterLocations () {
    // This method is called on input, but the filtering is handled by the computed property
    // We could add additional logic here if needed in the future
  }

  handleClickOutside (event: Event) {
    const target = event.target as HTMLElement;
    if (!this.$el.contains(target)) {
      this.isDropdownOpen = false;
    }
  }

  // updateCategory(e: HTMLFormElement, isvalid: boolean) {
  updateCategory () {
    // if (!isvalid) {
    if (!this.imageType || this.imageType === 2) {
      MenuApi.update(
        this.setData(),
        this.menuId,
        this.categoryId,
      )
        .then((response: any) => {
          // this.restore(e, defaultText);
          this.$notify({
            title: 'UPDATES SAVED!',
            verticalAlign: 'bottom',
            horizontalAlign: 'left',
            message: 'Changes have been saved successfully',
            type: 'success',
            icon: 'fas fa-check',
          });
          /* @ts-ignore */
          analytics.track('update_menu', {
            menud_id: this.menuId,
          });

          // this.$router.go(-1);
          this.$router.push({
            path: `/menus/${this.$route.params.id}/categories/${this.$route.params.catId}/1`,
          });
          // location.reload()
        })
        .catch((err: any) => {
          this.$notify({
            title: 'SYSTEM ERROR!',
            verticalAlign: 'bottom',
            horizontalAlign: 'left',
            message: err.response.data.error.detail,
            type: 'danger',
            icon: 'fas fa-bomb',
          });
        });
    } else {
      MenuApi.updateFormdata(
        this.formData(),
        this.menuId,
        this.categoryId,
      )
        .then((response: any) => {
          this.imageType = 0;
          this.categories[0].attributes['image-uri'] =
              response.data.data.attributes['image-uri'];
          // this.restore(e, defaultText);
          this.$notify({
            title: 'UPDATES SAVED!',
            verticalAlign: 'bottom',
            horizontalAlign: 'left',
            message: 'Changes have been saved successfully',
            type: 'success',
            icon: 'fas fa-check',
          });
          /* @ts-ignore */
          analytics.track('update_menu', {
            menud_id: this.menuId,
          });
          // this.$router.go(-1);
          this.$router.push({
            path: `/menus/${this.$route.params.id}/categories/${this.$route.params.catId}/1`,
          });
        })
        .catch((err: any) => {
          this.$notify({
            title: 'SYSTEM ERROR!',
            verticalAlign: 'bottom',
            horizontalAlign: 'left',
            message: 'Something went wrong, please try again!',
            type: 'danger',
            icon: 'fas fa-bomb',
          });
        });
    }
    // }
  }

  formData () {
    const formData = new FormData();
    formData.append('code', this.categories[0].attributes.code);
    formData.append(
      'display-order',
      this.categories[0].attributes['display-order'].toString(),
    );
    formData.append(
      'enabled',
      this.categories[0].attributes.enabled.toString(),
    );
    for (const i in this.categories) {
      formData.append(`name[${this.categories[i].lang}]`, this.categories[i].attributes.name ? this.categories[i].attributes.name : '');
      formData.append(`description[${this.categories[i].lang}]`, this.categories[i].attributes.description ? this.categories[i].attributes.description : '');
    }
    for (const i in this.selectedApplications) {
      formData.append(`apps[${i}]`, this.selectedApplications[i]);
    }

    let locations = this.selectedLocations;
    if (this.isMenuRestaurant) {
      locations = [...this.selectedLocations, ...this.notBelongLocations];
    }

    for (const i in locations) {
      formData.append(`locations[${i}]`, locations[i]);
    }
    formData.append('image', this.$refs.file.files[0]);
    return formData;
  }

  setData () {
    for (const i in this.categories) {
      this.catNames[this.categories[i].lang] = this.categories[
        i
      ].attributes.name;
      this.catDesc[this.categories[i].lang] = this.categories[
        i
      ].attributes.description;
    }

    let locations = this.selectedLocations;
    if (this.isMenuRestaurant) {
      locations = [...this.selectedLocations, ...this.notBelongLocations];
    }

    return {
      code: this.categories[0].attributes.code,
      'display-order': this.categories[0].attributes['display-order'],
      enabled: this.categories[0].attributes.enabled,
      name: this.catNames,
      description: this.catDesc,
      apps: this.selectedApplications,
      locations,
      'image-uri': this.categories[0].attributes['image-uri'],
    };
  }

  filesChange (e: any, errors: any) {
    if (typeof e.target.files[0] !== undefined) {
      this.file = e.target.files[0];
    }
  }
}
